import { Modal, Text, Group, Stack, ThemeIcon, Box, UnstyledButton, Anchor } from '@mantine/core';
import { IconCompass, IconMapPin } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import classes from './new-trip-modal.module.css';

interface NewTripModalProps {
  opened: boolean;
  onClose: () => void;
  clientId: string;
  tripProfileId: string;
}

interface ChoiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick: () => void;
}

function ChoiceCard({ icon, title, description, onClick }: ChoiceCardProps) {
  return (
    <UnstyledButton className={classes.card} onClick={onClick}>
      <Stack align="center" gap="sm">
        <ThemeIcon size={56} radius="xl" variant="light">
          {icon}
        </ThemeIcon>
        <Text fw={600} size="md" ta="center">
          {title}
        </Text>
        <Text size="sm" c="dimmed" ta="center">
          {description}
        </Text>
      </Stack>
    </UnstyledButton>
  );
}

function NewTripModal({ opened, onClose, clientId, tripProfileId }: NewTripModalProps) {
  const navigate = useNavigate();
  const basePath = `/clients/${clientId}/trip-profiles/${tripProfileId}`;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="How would you like to find a destination?"
      centered
      size="lg"
      closeButtonProps={{ 'aria-label': 'Decide later' }}
    >
      <Stack gap="xl">
        <Group grow align="stretch" gap="md">
          <ChoiceCard
            icon={<IconCompass size={28} />}
            title="Discover a Destination"
            description="Answer a few questions about travel style and let VoyLogic surface the best-fit destinations."
            onClick={() => {
              onClose();
              navigate(basePath);
            }}
          />
          <ChoiceCard
            icon={<IconMapPin size={28} />}
            title="Jump to Map"
            description="Already have a destination in mind? Go straight to the map and pick it directly."
            onClick={() => navigate(`${basePath}/map-results?showResults=false`)}
          />
        </Group>

        <Box ta="center">
          <Anchor size="sm" c="dimmed" onClick={onClose}>
            I'll decide later
          </Anchor>
        </Box>
      </Stack>
    </Modal>
  );
}

export default NewTripModal;
